import { useState } from 'react';

// pick a date util library
import { Autocomplete, Button, TextField } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

function LedgerHeader({ level3Codes, searchCallback }) {
  console.log(level3Codes);
  const width = 600;
  const marginTop = 20;
  const [level3, setLevel3] = useState('');
  const [site, setSite] = useState('');
  const [l3Update, setL3Update] = useState(false);

  let d = new Date();
  d.setMonth(d.getMonth() - 1);
  const [startDate, setStartDate] = useState(d);
  const [endDate, setEndDate] = useState(new Date());
  const [sites, setSites] = useState([{ id: 0, description: 'All sites' }]);

  const handleCodeLevel3 = event => {
    const [code, detail] = event.target.value.split('\t');
    const [l1code, l2code, l3code] = code.split('-');
    setLevel3({
      fullcode: code,
      desc: detail,
      l1code,
      l2code,
      l3code,
    });
  };

  const handleSite = event => {
    const [code, desc] = event.target.value.split('\t');
    setSite({ code, desc });
  };

  const handleStartDate = event => {
    setStartDate(event);
  };

  const handleEndDate = event => {
    setEndDate(event);
  };

  const handleSearch = () => {
    if (level3.code == '') {
      alert('Please select all fields.');
    } else {
      searchCallback(level3, startDate, endDate, site);
    }
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'center',
        marginTop: 5,
        height: '90vh',
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          alignItems: 'center',
          width: width,
          marginTop: marginTop,
        }}
      >
        <Autocomplete
          key={l3Update}
          onBlurCapture={handleCodeLevel3}
          disablePortal
          id="combo-box-code"
          getOptionLabel={option =>
            option.fullcode + '\t' + '' + '\t' + option.name
          }
          options={level3Codes}
          renderInput={params => (
            <TextField
              {...params}
              style={{ width: '300px' }}
              label="Level Three Code"
            />
          )}
        />
      </div>
      {/* <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          alignItems: 'center',
          marginTop: marginTop,
        }}
      >
        <Autocomplete
          onBlurCapture={handleSite}
          disablePortal
          id="combo-box-code"
          getOptionLabel={option =>
            option.id + '\t' + option.description + '\t'
          } //<--
          options={sites}
          renderInput={params => (
            <TextField
              {...params}
              style={{ width: '300px' }}
              label="Select Site"
            />
          )}
        />
      </div> */}
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
          width: '300px',
          marginTop: marginTop,
        }}
      >
        <lebel style={{ width: "140px" }}>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DatePicker
            size="small"
            label="Ledger Start Date"
            value={startDate}
            onChange={(event) => handleStartDate(event)}
            disableFuture
            InputProps={{ disableUnderline: true }}
          />
        </LocalizationProvider>
      </lebel>
      <lebel style={{ width: "140px" }}>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DatePicker
            size="small"
            label="Ledger End Date"
            value={endDate}
            onChange={(event) => handleEndDate(event)}
            disableFuture
            InputProps={{ disableUnderline: true }}
          />
        </LocalizationProvider>
      </lebel>
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-evenly',
          alignItems: 'center',
          width: '90%',
        }}
      >
        <Button
        disabled={level3 === ''}
          style={{
            backgroundColor: '#379683',
            color: 'white',
            marginTop:'10px',
            width: '300px',
          }}
          onClick={handleSearch}
        >
          Search
        </Button>
      </div>
    </div>
  );
}

export default LedgerHeader;
